/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics
 */

import marketHero from "../../img/carousel-1.jpg";

export default function MarketHero() {

    return (

        <section
            className="
                relative
                h-[500px]
                overflow-hidden
            "
        >

            {/* BACKGROUND IMAGE */}

            <img
                src={marketHero}
                alt="Market Landscape"
                className="
                    absolute
                    inset-0
                    w-full
                    h-fit
                    object-cover
                "
            />

            {/* OVERLAY */}

            <div
                className="
                    absolute
                    inset-0
                    bg-slate-900/70
                "
            />

            {/* CONTENT */}

            <div
                className="
                    relative
                    z-5
                    h-full
                    max-w-7xl
                    mx-auto
                    px-8
                    flex
                    items-center
                "
            >

                <div className="max-w-4xl h-[100px]">

                    <span
                        className="
                            inline-block
                            px-4
                            py-2
                            rounded-full
                            bg-blue-500/20
                            border
                            border-blue-400/30
                            text-blue-200
                            text-sm
                            font-medium
                            mb-6
                        "
                    >
                        Real-Time Market Intelligence
                    </span>

                    <h1
                        className="
                            text-6xl
                            font-black
                            text-white
                            leading-tight
                        "
                    >
                        Market Landscape
                    </h1>

                    <p
                        className="
                            mt-6
                            text-xl
                            text-slate-200
                            leading-relaxed
                            max-w-3xl
                        "
                    >
                        Track market trends, breadth,
                        volatility, macroeconomic indicators,
                        derivatives activity and global market
                        developments through a unified analytics
                        platform.
                    </p>

                </div>

            </div>

        </section>

    );

}